import React, { useState } from "react"
import { useSearchBox, useInstantSearch } from "react-instantsearch"
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid"
import { ArrowPathIcon } from "@heroicons/react/24/solid"

// Search Box
const CustomSearch = props => {
  const { refine, query } = useSearchBox(props)
  const { status } = useInstantSearch()
  const [inputValue, setInputValue] = useState(query)

  function setQuery(newQuery) {
    setInputValue(newQuery)

    refine(newQuery)
  }
  return (
    <form noValidate action="" role="search">
      <label htmlFor="search" className="sr-only">
        Search
      </label>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          {status === "stalled" ? (
            <ArrowPathIcon className="h-5 w-5 animate-spin text-gray-300" />
          ) : (
            <MagnifyingGlassIcon className="h-5 w-5 text-slate-400" />
          )}
        </div>
        <input
          aria-label="search"
          id="search"
          className="block w-full rounded-md border-0 bg-white py-2 pl-10 pr-3 leading-5 placeholder-slate-500 ring-1 ring-slate-300 transition focus:placeholder-slate-400 focus:ring focus:ring-blue-300 sm:text-sm"
          placeholder="Search"
          type="search"
          value={inputValue}
          onChange={event => setQuery(event.currentTarget.value)}
        />
      </div>
    </form>
  )
}

export default CustomSearch
